import { useState } from "react";
import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";

interface ToggleStatsModeProps{
  setShowStats: (mode:string) => void;
  showStats: string;
}

function ToggleStatsMode(props:ToggleStatsModeProps) {
  const { showStats, setShowStats } = props;
  const [statsMode, setStatsMode] = useState(showStats);

  const handleStatsModeChange = (newStatsMode:string) => {
    setShowStats(newStatsMode);
    setStatsMode(newStatsMode);
  }
  const activeToggleButtonStyles = {
    backgroundColor: "#007bff",
    borderColor: "#007bff",
    color: "white",
    fontSize: "12px"
  }
  const inactiveToggleButtonStyles = {
    backgroundColor: "#545b62",
    borderColor: "#545b62",
    color: "#BBB",
    fontSize: "12px"
  }
  const getToggleButtonStyles = (value:string) => {
    if (value === statsMode) {
      return activeToggleButtonStyles;
    } else {
      return inactiveToggleButtonStyles;
    }
  }

  return (
    <div style={{ margin: "10px 40px 10px 0", display: "flex", alignItems: "baseline" }}>
      <strong style={{ marginRight: "10px" }}>Show stats for: </strong>
      <ToggleButtonGroup type="radio" name="statsMode" value={statsMode} onChange={handleStatsModeChange}>
        <ToggleButton style={getToggleButtonStyles("matched")} value="matched" size="sm" title="Shows stats only for the campaigns that match your search criteria.">Matching Campaigns</ToggleButton>
        <ToggleButton style={getToggleButtonStyles("overall")} value="overall" size="sm" title="Shows stats for all campaigns, both active and inactive, including campaigns not matching your search criteria.">All Campaigns</ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
}

export default ToggleStatsMode;